export default {"src":"/_next/static/media/paypal-logo.23e43cbf.svg","height":32,"width":101,"blurWidth":0,"blurHeight":0};